import {
  Card,
  CardBody,
  CardFooter,
  CardTop,
  CookieMessage,
  CookieMessageBody,
  CookieMessageRight,
} from "@adeccoux/tag-ds";
import React, { useEffect, useRef, useState } from "react";
import { isDesktop, isMobileOnly, isTablet } from "react-device-detect";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import {
  AssessmentFoundPopup,
  buildDeviceNames,
  buildReportData,
  CommonLoader,
  CommonPopup,
  Notifs,
  redirectToRC,
} from "../../util/common";
import {
  CHECK_CLIENT_COBRANDING,
  GET_ACCESSIBILTY_STATUS,
  GET_CANDIDATE_CHECK,
  GET_CANDIDATE_LIST,
  GET_CANDIDATE_USER_DETAILS,
  GET_ENCRYPTED_DATA,
  GET_NPS_URL,
  GET_PREVIEW_TEST,
  GET_TEST_INFO,
  INSTRUMENT_DEVICE_LIST,
  PREVIEW_TEST,
  QUALTRICS_REGISTRATION,
  SCORE_REUSE_ELIGIBILITY,
} from "../../util/constants";
import {
  getCall,
  getNoCacheCall,
  getReuseEligibilityDetails,
  postCall,
  reuseAssessmentResponses,
} from "../../util/resources";
import SesHeader from "../header";
import SessionCompleted from "../sessionCompletion/sessionCompletion";
import InformationScreen from "./informationScreen";
import LanguageSelector from "./languageSelector";
import cn from "classnames";
const WelcomeScreen = ({
  setAppPhrases,
  testPreviewOpened,
  RCLaunched,
  setRCLaunched,
  setSelectedLang,
}) => {
  const [user, setUser] = useState({});
  const [testDetails, setTestDetails] = useState(false);
  const [phrases, setPhrases] = useState({});
  const [accessibilityStatus, setAccessibilityStatus] = useState(null);
  const [grantExtratiming, setGrantExtratiming] = useState(null);
  const [deviceList, setDeviceList] = useState({});
  const [candidatereportcheck, setCandidatereportcheck] = useState(false);
  const [npsSurveyUrl, setNpsSurveyUrl] = useState(null);
  const [candidateList, setCandidateList] = useState([]);
  const [welcomeTemplate, setWelcomeTemplate] = useState();
  const [presentScreen, setPresentScreen] = useState("session");
  const [clientCobranding, setClientCobranding] = useState(false);
  const [cookieShow, setCookieShow] = useState(
    JSON.parse(sessionStorage.getItem("cookieShow")) !== null
      ? JSON.parse(sessionStorage.getItem("cookieShow"))
      : true
  );
  const [valiErrors, setValiErrors] = useState([false, false]);
  const [scope, setScope] = useState({});
  const [checkBoxes, setCheckBoxes] = useState([false, false]);
  const [submitClicked, setSubmitClicked] = useState(false);
  const [infoScreen, setInfoScreen] = useState(false);
  const [previewPage, setPreviewPage] = useState(false);
  const [showLangPopup, setShowLangPopup] = useState(false);
  const [popupData, setpopupData] = useState({
    isOpen: false,
    popupHeader: "",
    popupBody: "",
    popupFooter: "",
  });
  const searchP = location.hash.replace("#/", "");
  const [searchParams, setSearchParams] = useSearchParams(encodeURI(searchP));

  const navigate = useNavigate();
  const welcomeTempRef = useRef();
  const assessmentID = useRef();
  const valiErrorsRef = useRef([false, false]);
  const valiErrorsSetOnceRef = useRef(false);
  const links = {
    privacystatement: "privacyStatement",
    termsofuse: "termsOfUse",
    startsyscheck: "startsyscheck",
    disclaimer: "disclaimer",
  };
  const testsEligibleForReuse = useRef();
  const [pageRefresh, setPageRefresh] = useState(false);

  const sharePopupClose = () => {
    setShowLangPopup((prev) => !prev);
  };
  const timedAsses = phrases?.["20023549"]?.replace("!", "")?.split("-");

  const cssologout = () => {
    const href = "/control/admin/MultiSessionLogout";
    window.location.href = href;
  };

  const cssoBack = () => {
    window.history.back();
  };

  const signout = () => {
    sessionStorage.clear();
    const href = "/loginNew?stc=candidate";
    window.location.href = href;
  };

  const showStartTestButton = (test) => {
    let showButton = false;
    let scope;
    if (test.deviceType === 4 && isMobileOnly) {
      showButton = true;
    }
    if ((test.deviceType == 4 || test.deviceType == 2) && isTablet) {
      showButton = true;
    }
    if (
      (test.deviceType == 4 ||
        test.deviceType == 2 ||
        test.deviceType == 1 ||
        test.deviceType == 0) &&
      isDesktop
    ) {
      showButton = true;
    }

    if (scope?.accssibilityStatus === 1) {
      test.status.id = 3;
    }
    return showButton;
  };

  const regCandidateAtQualtrics = async (testId) => {
    try {
      const response = await postCall(
        QUALTRICS_REGISTRATION,
        {
          assignmentId: assessmentID.current,
          testId: testId,
        },
        {
          "X-Xpert-Session": assessmentID.current,
        }
      );
    } catch (error) {
      console.log(error);
    }
  };

  const termsAccepted = () => {
    const returnVal =
      (!scope.privacyRequired || !valiErrorsRef.current[0]) &&
      (!scope.termsRequired || !valiErrorsRef.current[1]);
    return returnVal;
  };

  const reuseResponses = async (test, user) => {
    let selectedTest = testsEligibleForReuse.current?.find(
      (eligibleTest) => eligibleTest?.testId == test?.id
    );
    selectedTest.currentAssignmentId = assessmentID?.current;
    let response = await reuseAssessmentResponses(selectedTest);

    if (response.status != 200) {
      console.log("Error while copying the responses.");
    }
    closePopUp();
    setPageRefresh(!pageRefresh);
  };

  const startAssessment = async (test, user) => {
    if (!previewPage) {
      setSubmitClicked(true);
      sessionStorage.setItem("test", JSON.stringify(test));
      setCookieShow(false);
      sessionStorage.setItem("cookieShow", JSON.stringify(false));
      await handleScreenData(testDetails, true);
      await regCandidateAtQualtrics(test.id);
      if (termsAccepted()) {
        if (test.provider) {
          if (test.urlProvider) {
            window.location.replace(test.urlProvider);
          } else {
            try {
              const url =
                "/rest/tt/urlprovider/" + test.id + "/" + test.instrumentType;
              const response = await getNoCacheCall(url, {
                "X-Xpert-Session": assessmentID.current,
              });
              if (response.data) {
                window.location.replace(response.data);
              } else {
                console.error("there's no info about third party test;");
                setpopupData((prev) => {
                  prev = {
                    ...prev,
                    isOpen: true,
                    popupBody: phrases?.["1002044"],
                    popupFooter: phrases?.["10928"],
                  };
                  return prev;
                });
              }
            } catch (error) {
              console.error(error, "error trying to recover third party test;");
              setpopupData((prev) => {
                prev = {
                  ...prev,
                  isOpen: true,
                  popupBody: phrases?.["1002044"],
                  popupFooter: phrases?.["10928"],
                };
                return prev;
              });
            }
          }
        } else if (test.scorm) {
          const ScormLink =
            "/testlauncher/#/?testId=" +
            test.id +
            "&instrumentType=" +
            test.instrumentType;
          var scormwindow = window.open(
            ScormLink,
            "scorm_blank",
            "resizable=yes,fullscreen=yes,height=" +
            window.outerHeight +
            ",width=" +
            window.outerWidth +
            ",scrollbars=no"
          );
          scormwindow.onunload = function () {
            window.location.reload(false);
          };
        } else {
          if ([1, 2, 11, 12].includes(test.testType)) {
            let testEligible = testsEligibleForReuse.current?.find(
              (eligibleTest) => eligibleTest?.testId == test?.id
            );

            if (testEligible) {
              setpopupData({
                isOpen: true,
                assessmentFound: true,
                popupHeader: phrases?.["26000104"],
                popupBody: phrases?.["26000107"]?.replace(
                  "$[DATE]$",
                  testEligible?.assCompletionDate?.split(" ")[0]
                ),
                test: test,
                user: user,
              });
            } else {
              launchTest(test, user);
            }
          } else {
            launchTest(test, user);
          }
        }
      }
    }
  };

  const launchTest = (test, user) => {
    let sdemographics = sessionStorage.getItem("demographics");
    if (
      !sdemographics &&
      test.status.id == 1 &&
      user.siteConfig.demDisplay === "Y"
    ) {
      navigate("/demographics", {
        state: {
          user: user,
          test: test,
          cobrandingLink: clientCobranding,
          demographics: false,
        },
      });
    } else {
      navigate("/instructions", {
        state: {
          user: user,
          test: test,
          cobrandingLink: clientCobranding,
        },
      });
    }
  };

  const checkSelected = (shouldSelected) => {
    if (shouldSelected) {
      if (document.getElementById("user.privacyAccepted")) {
        setCheckBoxes((prev) => [true, prev[1]]);
        document.getElementById("user.privacyAccepted").checked = true;
      }

      if (document.getElementById("user.termsAccepted")) {
        setCheckBoxes((prev) => [prev[0], true]);
        document.getElementById("user.termsAccepted").checked = true;
      }
    }
  };

  const handleScreenData = async (tests, submitted = false) => {
    let localScope = {};
    localScope.showRetryButton = false;
    localScope.showLoadingSpinner = true;
    let i,
      tt = tests,
      ttl = tests.length,
      sc = true,
      pv = false,
      pa = false,
      nm = false;
    for (i = 0; i < ttl; i++) {
      if (
        tt[i].timeByQuestion == true ||
        tt[i].timedByTopic == true ||
        tt[i].timeLimit != 0
      ) {
        localScope.timeAssessment = true;
      }

      if (tt[i].resetStatus == true) {
        localScope.resetAssessment = true;
      }
      localScope.validationSession =
        localScope.validationSession || tt[i].validation === true;
      pv = pv || (tt[i].validation === true && tt[i].status.id !== 2);
      sc = sc && tt[i].status.id === 2;
      pa = tt[i].status.id !== 1;
      nm = nm || !showStartTestButton(tt[i]);
      if (!submitted) checkSelected(tt[i].status.id !== 1);
    }
    localScope.sessionCompleted = sc;
    localScope.hasPendingValidations = pv;
    localScope.mixedTypes = nm;

    if (submitted || (sc && ttl > 0) || pv || pa) {
      if (scope.privacyRequired === true) {
        const elem = document.getElementById("user.privacyAccepted");
        if (elem.checked) {
          setValiErrors((prev) => {
            valiErrorsRef.current = [false, prev[1]];
            return [false, prev[1]];
          });
        } else {
          setValiErrors((prev) => {
            valiErrorsRef.current = [true, prev[1]];
            return [true, prev[1]];
          });
          welcomeTempRef.current.scrollIntoView();
        }
      }
      if (scope.termsRequired === true) {
        const elem = document.getElementById("user.termsAccepted");
        if (elem.checked) {
          setValiErrors((prev) => {
            valiErrorsRef.current = [prev[0], false];
            return [prev[0], false];
          });
        } else {
          setValiErrors((prev) => {
            valiErrorsRef.current = [prev[0], true];
            return [prev[0], true];
          });
          welcomeTempRef.current.scrollIntoView();
        }
      }
    }
    localScope.showLoadingSpinner = false;
    localScope.isWelcomeScreen = !localScope.sessionCompleted;

    setScope((prev) => ({ ...prev, ...localScope }));
  };

  const generateWelcomeTemplate = (template, user) => {
    if (template) {
      //extract the line that contents candidate name,  and convert it to title
      template = template.replace(
        /(.*\$template.candidateFirstName.*?)(.*\$template.candidateLastName.*?)?/,
        function (match, string, position, template) {
          let secondName, firstName;
          if (position === undefined) {
            secondName = string.replace(
              /\$template.candidateLastName/,
              `<span>${user.lastName}</span>`
            );
            firstName = secondName.replace(
              /\$template.candidateFirstName/,
              `<span>${user.firstName}</span>`
            );
            return "<h3 class='text-01'>" + firstName; // changes for Bug 3440
          } else {
            firstName = string.replace(
              /\$template.candidateFirstName/,
              `<span>${user.firstName}</span>`
            );
            secondName = position.replace(
              /\$template.candidateLastName/,
              `<span>${user.lastName}</span>`
            );
            return "<h3>" + firstName + secondName; // changes for Bug 3440
          }
        }
      );

      //remove whitespaces, we don't need them
      template = template.replace(/\r?\n|\r/g, "");
      //replace checkboxes
      template = template.replace(
        /\$template.checkbox(.*?)html(.*?)<br\s*\/?>/gi,
        function (match, key, label, position, template) {
          switch (key) {
            case "privacystatement":
              key = "user.privacyAccepted";
              setScope((prev) => ({
                ...prev,
                privacyRequired: true,
              }));
              break;
            case "termsofuse_":
              key = "user.termsAccepted";
              setScope((prev) => ({
                ...prev,
                termsRequired: true,
              }));
              break;
          }

          return `<span class="checkbox-container m0 mb1">
                        <input id=${key} type="checkbox" ${key === "user.privacyAccepted"
              ? checkBoxes[0]
                ? "checked"
                : ""
              : checkBoxes[1]
                ? "checked"
                : ""
            } onclick="((event)=>
                    {
                        const ev = new CustomEvent('customClick', { detail: '${key}'}); 
                        window.dispatchEvent(ev);
                    })(event)"/>
                        <label class="flex justify-content_start" style="align-items: baseline;width: auto;text-transform:none !important" for=${key}>
                        ${label}
                        </label>
                    </span>`;
        }
      );

      //replace links
      template = template.replace(
        /\$template.(\S*?)linkinit\b\s(.*?)\s\$template.linkend/gi,
        function (match, key, label, position, template) {
          let state;
          switch (key) {
            case "privacystatement":
              state = links["privacystatement"];
              break;
            case "termsofuse":
              state = links["termsofuse"];
              break;
            case "startsyscheck":
              state = links["startsyscheck"];
              break;
            case "disclaimer":
              state = links["disclaimer"];
              break;
          }

          if (key === "disclaimer") {
            return `<a role="link" style="display:block; text-transform:uppercase" onclick="((event)=>
                        {
                            event.stopPropagation();
                            const ev = new CustomEvent('customClick', { detail: '${state}'}); 
                            window.dispatchEvent(ev);
                        })(event)">
                        ${label}</a>`;
          }

          return `<a role="link" onclick="((event)=>
                    {
                        event.stopPropagation();
                        const ev = new CustomEvent('customClick', { detail: '${state}'}); 
                        window.dispatchEvent(ev);
                    })(event)"  style="display:inline; text-transform:uppercase">&nbsp;
                        ${label}</a>`;
        }
      );

      template = template.replace(
        /#if\s\(\$template.(\S*?)\)(.*?)#end/gi,
        function (match, key, label, position, template) {
          return (
            '<span ng-show="template' +
            key.capitalize() +
            '">' +
            label +
            "</span>"
          );
        }
      );

      template = template.replace(/(<br\s*\/?>){2}/gi, "<div></div>");
      /* Bug 3440 fixes  */
      let finalTemplate;
      if (template.split("<br>")[0]) {
        finalTemplate =
          template.split("<div>")[0] +
          "</h3>" +
          template.substring(template.indexOf("<div>"));
      }
      finalTemplate = finalTemplate.replace(/<br[^>]*>/g, "");
      finalTemplate = finalTemplate.split("</div>");
      finalTemplate = finalTemplate.map((val) => {
        return `<span>${val}</span>`;
      });

      finalTemplate = finalTemplate.join("");
      finalTemplate = finalTemplate.replace(/<div[^>]*>/g, "");

      // Add language selector link if not preview page
      if (!previewPage) {
        const langPhrase = phrases?.["114"] ? phrases?.["114"] : JSON.parse(sessionStorage.getItem("phrases"))?.["114"];
        const langLinkHtml = `<a class="text_uppercase flex g1 align-items_center" role="link" onclick="((event)=>{event.stopPropagation();const ev = new CustomEvent('customClick', { detail: 'languageSelector'}); window.dispatchEvent(ev);})(event)">
          <span class="material-icons">language</span> ${langPhrase}
          <span class="material-icons-outlined left pl1"></span>
        </a>`;
        finalTemplate = finalTemplate + langLinkHtml;
      }

      setWelcomeTemplate(finalTemplate);
    }
  };

  const cookieMsg = () => {
    let cookieTemplate = user?.siteConfig?.templatesConfig?.bannerTemplate;
    if (cookieTemplate) {
      cookieTemplate = cookieTemplate.replace(
        /\$template.privacyStatementLink/g,
        function (cookieTemplate) {
          const linkId = phrases?.["1001570"];
          return `<a role="link"  class="text_uppercase" onclick="((event)=>
                    {
                        event.stopPropagation();
                        const ev = new CustomEvent('customClick', { detail: '${links["privacystatement"]}'}); 
                        window.dispatchEvent(ev);
                    })(event)" style="display:contents">
                        ${linkId}</a>`;
        }
      );
      return cookieTemplate;
    }
  };

  const handleInfoScreen = (event) => {
    if (event.detail === "user.privacyAccepted") {
      setCheckBoxes((prev) => [!prev[0], prev[1]]);
    } else if (event.detail === "user.termsAccepted") {
      setCheckBoxes((prev) => [prev[0], !prev[1]]);
    } else if (event.detail === "languageSelector") {
      setShowLangPopup((prev) => !prev);
    } else setInfoScreen(event.detail);
  };

  const closePopUp = () => {
    setpopupData((prev) => {
      prev = { ...prev, isOpen: false };
      return prev;
    });
  };

  useEffect(() => {
    let elem;
    if (infoScreen === false) {
      if (scope.privacyRequired === true) {
        elem = document.getElementById("user.privacyAccepted");
        elem.checked = checkBoxes[0];
      }
      if (scope.termsRequired === true) {
        elem = document.getElementById("user.termsAccepted");
        elem.checked = checkBoxes[1];
      }
    }
  }, [infoScreen]);

  useEffect(() => {
    if (infoScreen === false && (valiErrors[0] || valiErrors[1])) {
      valiErrorsSetOnceRef.current = false;
    }
    try {
      if (
        welcomeTemplate &&
        (valiErrors[0] || valiErrors[1]) &&
        !valiErrorsSetOnceRef.current
      ) {
        valiErrorsSetOnceRef.current = true;
        let oldElem = document.getElementById("vali_errors");
        let elem;
        if (scope.privacyRequired) {
          elem = document.getElementById("user.privacyAccepted");
        } else if (scope.privacyRequired) {
          elem = document.getElementById("user.termsAccepted");
        } else {
          elem = false;
        }
        if (oldElem && elem) {
          elem = elem.parentNode;
          const i = Array.from(elem.parentNode.children).indexOf(elem);
          elem = elem.parentNode;
          elem.insertBefore(oldElem.childNodes[0], elem.children[i]);
        }
      }
    } catch (error) { }
  }, [welcomeTemplate, valiErrors, infoScreen]);

  useEffect(() => {
    if (testDetails && (user?.fromStandalone || user?.fromBH)) {
      let testsWithEiligibleTypes = testDetails
        ?.filter((test) => [1, 2, 11, 12].includes(test.testType))
        ?.map((test) => test.id);
      if (testsWithEiligibleTypes?.length > 0) {
        getReuseEligibilityDetails(user?.id, testsWithEiligibleTypes).then(
          (resp) => {
            testsEligibleForReuse.current = resp?.data
              ?.filter((test) => test?.eligibleForReuse)
              ?.map((test) => ({
                ...test,
                currentAssignmentId: assessmentID.current,
              }));
          }
        ).catch(err => console.log("Error while fetching eligibility details", err));
      }
    }
  }, [testDetails]);

  useEffect(() => {
    sessionStorage.setItem("urlParams", location.hash);
    const initNetworkCalls = async () => {
      try {
        if (
          searchParams.get("em_enc") === "true" &&
          searchParams.get("email_dec") !== "true"
        ) {
          const nocache = new Date().getTime();
          const shlUrl = `/rest/tt/SHLEmailDecrypt?noCache=${nocache}&emailEnc=${searchParams.get(
            "al_email"
          )}`;
          const shlEmailDecryption = await getCall(shlUrl);
          let emailFlag = false;
          if (shlEmailDecryption.data != "") {
            searchParams.set("al_email", shlEmailDecryption.data);
            emailFlag = true;
          }
          window.location.replace(
            `/testlauncher/#/?display=welcome&al_email=${searchParams.get(
              "al_email"
            )}&al_password=${searchParams.get(
              "al_password"
            )}&em_enc=true&email_dec=${emailFlag}`
          );
        }
        const userDetailsResponse = await postCall(GET_CANDIDATE_USER_DETAILS, {
          user: searchParams.get("al_email"),
          password: decodeURIComponent(searchParams.get("al_password")),
          dataPrivacy: searchParams.get("display"),
          encrypted: true,
          inbranch: searchParams.get("inbranch") || false,
          csso: searchParams.get("csso"),
          assignmentId: searchParams.get("al_assignment_id"),
        });
        setUser(userDetailsResponse.data);
        setPhrases(userDetailsResponse.data.siteConfig.phrases);
        setAppPhrases(userDetailsResponse.data.siteConfig.phrases);
        sessionStorage.setItem(
          "session_data",
          JSON.stringify(userDetailsResponse.data)
        );
        sessionStorage.setItem(
          "templates",
          JSON.stringify(userDetailsResponse.data?.siteConfig?.templatesConfig)
        );
        if (
          searchParams.get("display") === "dataprivacy" &&
          !testPreviewOpened.current
        ) {
          testPreviewOpened.current = true;
          setInfoScreen("privacyStatement");
        }
        sessionStorage.setItem(
          "phrases",
          JSON.stringify(userDetailsResponse.data.siteConfig.phrases)
        );
        generateWelcomeTemplate(
          userDetailsResponse.data?.siteConfig?.templatesConfig
            ?.welcomeTemplate,
          userDetailsResponse.data
        );
        userDetailsResponse.data.sessionId =
          userDetailsResponse.headers["x-xpert-session"];
        sessionStorage.setItem(
          "session_data",
          JSON.stringify(userDetailsResponse.data)
        );
        document.title = userDetailsResponse.data.siteConfig.phrases["14516"];
        const header = {
          "X-Xpert-Session": userDetailsResponse.headers["x-xpert-session"],
        };
        assessmentID.current = userDetailsResponse.headers["x-xpert-session"];
        const [
          testDetailsResponse,
          accessibilityStatusResponse,
          deviceListResponse,
          candidatereportcheckResponse,
          npsSurveyUrlResponse,
          candidateListResponse,
          clientCobrandingResponse,
        ] = await Promise.all([
          getNoCacheCall(GET_TEST_INFO, header),
          getNoCacheCall(GET_ACCESSIBILTY_STATUS, header),
          getNoCacheCall(INSTRUMENT_DEVICE_LIST, header),
          getNoCacheCall(GET_CANDIDATE_CHECK, header),
          getNoCacheCall(
            GET_NPS_URL +
            `?assignmentId=${userDetailsResponse.headers["x-xpert-session"]}`,
            header
          ),
          getNoCacheCall(GET_CANDIDATE_LIST, header),
          getNoCacheCall(CHECK_CLIENT_COBRANDING, header),
        ]);
        setTestDetails(testDetailsResponse.data);
        setAccessibilityStatus(accessibilityStatusResponse.data[0]);
        setGrantExtratiming(accessibilityStatusResponse.data[1]);
        setDeviceList(deviceListResponse.data);
        setCandidatereportcheck(candidatereportcheckResponse.data);
        setNpsSurveyUrl(npsSurveyUrlResponse.data.response);
        setCandidateList(
          buildReportData(candidateListResponse.data, testDetailsResponse.data)
        );
        if (clientCobrandingResponse.data !== "") {
          const clientLogoId = clientCobrandingResponse.data.split("###")[0];
          const clientLogoImgUrl =
            "/client_logo/" + clientCobrandingResponse.data.split("###")[1];
          setClientCobranding(clientLogoImgUrl);
          sessionStorage.setItem("clientLogo", clientLogoImgUrl);
        }
        handleScreenData(testDetailsResponse.data);
        sessionStorage.setItem(
          "test_details",
          JSON.stringify(testDetailsResponse.data)
        );
        if (searchParams.get("display") === "runtest") {
          let demSkipUser = userDetailsResponse.data;
          demSkipUser.siteConfig.demDisplay = "N";
          const redirectURL = decodeURIComponent(
            searchParams.get("redirectURL")
          );
          if (RCLaunched) redirectToRC();
          if (
            redirectURL != undefined &&
            redirectURL != null &&
            redirectURL != ""
          ) {
            sessionStorage.setItem("redirectUrl", redirectURL);
          }
          setUser(demSkipUser);
          setRCLaunched(true);
          startAssessment(testDetailsResponse.data[0], demSkipUser);
        }
      } catch (error) {
        console.log(error);
        setpopupData({
          isOpen: true,
          popupHeader: "Error",
          popupBody: "Server Error - Can't retrieve tests listing",
          popupFooter: phrases?.["10928"] || "Continue",
        });
      }
    };
    const previewPageInit = async () => {
      try {
        const colleague = JSON.parse(sessionStorage.getItem("colleague"));
        const userDetailsResponse = await getCall(PREVIEW_TEST);
        userDetailsResponse.data.inBranch = true;
        setUser(userDetailsResponse.data);
        generateWelcomeTemplate(
          userDetailsResponse.data?.siteConfig?.templatesConfig
            ?.welcomeTemplate,
          userDetailsResponse.data
        );
        sessionStorage.setItem(
          "templates",
          JSON.stringify(userDetailsResponse.data?.siteConfig?.templatesConfig)
        );
        sessionStorage.setItem(
          "phrases",
          JSON.stringify(userDetailsResponse.data.siteConfig.phrases)
        );
        sessionStorage.setItem(
          "session_data",
          JSON.stringify(userDetailsResponse.data)
        );
        document.title = userDetailsResponse.data.siteConfig.phrases["14516"];
        setPhrases(userDetailsResponse.data.siteConfig.phrases);
        setAppPhrases(userDetailsResponse.data.siteConfig.phrases);
        setTestDetails([
          {
            status: {
              tag: "Start Assessment",
              id: 1,
              disabled: false,
            },
            displayType: "1",
            instrumentTypeName: "Assessment",
            name: "Example Test #001",
            testExampleName: "Example Test #001",
            deviceType: 4,
            instrumentType: 1,
            id: 17,
            testType: 1,
            timeLimit: 0,
            grantExtraTime: false,
            timedByTopic: false,
            timeByQuestion: false,
          },
        ]);
        setDeviceList({
          desktopIcon: "desktop.svg",
          tabletIcon: "tablet.svg",
          smartphoneIcon: "smartphone.svg",
          desktopLabel: "Desktops/Laptops",
          tabletLabel: "Tablets",
          smartphoneLabel: "Smartphones",
        });
        const clientLogoImgUrl =
          "/client_logo/" + sessionStorage.getItem("clientLogo");
        setClientCobranding(clientLogoImgUrl);
      } catch (error) {
        console.log(error);
        setpopupData({
          isOpen: true,
          popupHeader: "Error",
          popupBody: "Server Error - Can't retrieve tests listing",
          popupFooter: phrases?.["10928"] || "Continue",
        });
      }
    };
    const tmPreviewInit = async () => {
      try {
        if (!testPreviewOpened.current) {
          testPreviewOpened.current = true;
          let userDetailsResponse;
          if (
            searchParams.get("testType") != null &&
            searchParams.get("INSTRUCTION") != null
          ) {
            userDetailsResponse = await getNoCacheCall(
              GET_PREVIEW_TEST +
              `?SESSION=${searchParams.get(
                "SESSION"
              )}&NAME=${searchParams.get("NAME")}&GROUP=${searchParams.get(
                "GROUP"
              )}&INSTRUCTION=${searchParams.get(
                "INSTRUCTION"
              )}&testType=${searchParams.get(
                "testType"
              )}&TRYOUT=${searchParams.get(
                "TRYOUT"
              )}&EXAMPLE=${searchParams.get(
                "EXAMPLE"
              )}&checkUI=${searchParams.get(
                "checkUI"
              )}&fullTestPreview=${searchParams.get(
                "fullTestPreview"
              )}`
            );
          } else {
            userDetailsResponse = await getNoCacheCall(
              GET_PREVIEW_TEST +
              `?SESSION=${searchParams.get(
                "SESSION"
              )}&NAME=${searchParams.get("NAME")}&GROUP=${searchParams.get(
                "GROUP"
              )}&TRYOUT=${searchParams.get(
                "TRYOUT"
              )}&EXAMPLE=${searchParams.get(
                "EXAMPLE"
              )}&checkUI=${searchParams.get(
                "checkUI"
              )}&fullTestPreview=${searchParams.get(
                "fullTestPreview"
              )}`
            );
          }
          document.title = userDetailsResponse.data.siteConfig.phrases["14516"];
          sessionStorage.setItem(
            "session_data",
            JSON.stringify(userDetailsResponse.data)
          );
          sessionStorage.setItem(
	        "phrases",
	        JSON.stringify(userDetailsResponse.data.siteConfig.phrases)
	      );
          setPhrases(userDetailsResponse.data.siteConfig.phrases);
          setAppPhrases(userDetailsResponse.data.siteConfig.phrases);
          navigate("/instructions", {
            state: {
              user: userDetailsResponse.data,
              test: userDetailsResponse.data.test,
              previewData: userDetailsResponse.data.arrQuestionsPage,
              isNotExampleTest: searchParams.get(
                "EXAMPLE"
              ) == 'N',
              fullTestPreview: searchParams.get('fullTestPreview') === 'Y'
            },
          });
        } else {
          window.close();
        }
      } catch (error) {
        console.log(error);
        setpopupData({
          isOpen: true,
          popupHeader: "Error",
          popupBody: "Server Error - Can't retrieve tests listing",
          popupFooter: phrases?.["10928"] || "Continue",
        });
      }
    };
    if (searchParams.get("testId")) {
      navigate("/scorm");
    } else if (searchParams.get("preview")) {
      if (searchParams.get("SESSION")) {
        tmPreviewInit();
      } else {
        setPreviewPage(true);
        previewPageInit();
      }
    } else {
      initNetworkCalls();
    }
    window.addEventListener("customClick", handleInfoScreen);
    return () => {
      window.removeEventListener("customClick", handleInfoScreen);
    };
  }, [pageRefresh]);

  if (!welcomeTemplate || searchParams.get("display") === "runtest") {
    return <CommonLoader />;
  }
  setSelectedLang(user?.siteConfig?.langId);

  return (
    <>
      {popupData?.assessmentFound ? (
        <AssessmentFoundPopup
          popupData={popupData}
          closeAction={closePopUp}
          launchAction={launchTest}
          reuseAction={reuseResponses}
          setterFun={setpopupData}
          phrases={phrases}
        />
      ) : (
        <CommonPopup
          popupData={popupData}
          closeAction={closePopUp}
          setterFun={setpopupData}
        />
      )}

      {infoScreen ? (
        <InformationScreen
          type={infoScreen}
          setInfoScreen={setInfoScreen}
          clientCobranding={clientCobranding}
        />
      ) : (
        <>
          <SesHeader clientCobranding={clientCobranding} />
          {scope.sessionCompleted ? (
            <SessionCompleted
              user={user}
              testDetails={testDetails}
              phrases={phrases}
              accessibilityStatus={accessibilityStatus}
              grantExtratiming={grantExtratiming}
              deviceList={deviceList}
              candidatereportcheck={candidatereportcheck}
              npsSurveyUrl={npsSurveyUrl}
              candidateList={candidateList}
              presentScreen={presentScreen}
              setPresentScreen={setPresentScreen}
            />
          ) : (
            <>
              <div id="vali_errors">
                {submitClicked && (
                  <div className="flex_col g1 full-width">
                    <>
                      {valiErrors[0] && (
                        <Notifs
                          type={"error"}
                          header={phrases?.["1001568"]}
                          body={""}
                          icon={"warning_amber"}
                        />
                      )}
                      {valiErrors[1] && (
                        <Notifs
                          type={"error"}
                          header={phrases?.["1001569"]}
                          body={""}
                          icon={"warning_amber"}
                        />
                      )}
                    </>
                  </div>)}
                <div
                  ref={welcomeTempRef}
                  className="flex_col g2 base text-02 xpert-align-self-stretch"
                  dangerouslySetInnerHTML={{
                    __html: welcomeTemplate,
                  }}
                >

                </div>
                {/* old code to be removed 
                {!previewPage && (
                  <a
                    className="text_uppercase"
                    role="link"
                    onClick={() => setShowLangPopup((prev) => !prev)}
                  >
                    <span className="material-icons">language</span>{" "}
                    {phrases?.["114"]}
                    <span className="material-icons-outlined left pl1"></span>
                  </a>
                )} */}
              </div>
              <hr></hr>
              {(scope.timeAssessment ||
                accessibilityStatus === 1 ||
                accessibilityStatus === 2 ||
                accessibilityStatus === 3 ||
                accessibilityStatus === 4 ||
                scope.resetAssessment === true) && (
                  <div className="flex_col g1 full-width">
                    {scope.timeAssessment && (
                      <Notifs
                        type={"info"}
                        header={timedAsses?.[0]}
                        body={timedAsses?.[1]}
                        icon={"info"}
                      />
                    )}
                    {(accessibilityStatus === 1 ||
                      accessibilityStatus === 2 ||
                      accessibilityStatus === 3 ||
                      accessibilityStatus === 4) && (
                        <Notifs
                          type={
                            accessibilityStatus === 1
                              ? "info"
                              : accessibilityStatus === 3
                                ? "error"
                                : "success"
                          }
                          header={phrases?.["20023508"]}
                          body={`${accessibilityStatus === 1 ? phrases?.["20023509"] : ""
                            } ${accessibilityStatus === 2 && grantExtratiming !== 0
                              ? phrases?.["20023510"]
                              : ""
                            } ${accessibilityStatus === 2 && grantExtratiming === 0
                              ? phrases?.["20023511"]
                              : ""
                            } ${accessibilityStatus === 3 ? phrases?.["20023512"] : ""
                            }`}
                          icon={"accessibility_new"}
                        />
                      )}
                    {scope.resetAssessment === true && (
                      <Notifs
                        type={"info"}
                        header={phrases?.["20023600"].split(".")[0]}
                        body={phrases?.["20023600"]?.substring(
                          phrases?.["20023600"]?.indexOf(".") + 1
                        )}
                        icon={"info"}
                      />
                    )}
                  </div>
                )}
              <div className="flex_col g2 xpert-align-self-stretch align-items_start g-container_12 welcome_instruments">
                <div className="flex flex_wrap  g2 xpert-align-self-stretch align-items_start">
                  {testDetails.length > 0 &&
                    testDetails.map((val, ind) => (
                      <div
                        key={ind}
                        className="flex g2 xpert-align-self-stretch align-items_start g-item_4 g-item_tablet_3 g-item_mobile_3 "
                      >
                        <Card>
                          <CardTop id="card top">
                            {(val.status.id === 1 || val.status.id === 4) && (
                              <div className="status-tag_success text_uppercase">
                                <span className="material-icons">
                                  outlined_flag
                                </span>
                                open
                              </div>
                            )}
                            {(val.status.id === 2 || val.status.id === 6) && (
                              <div className="status-tag_success text_uppercase">
                                <span className="material-icons">check</span>
                                {val.status.tag}
                              </div>
                            )}
                            {val.status.id === 3 && (
                              <div className="status-tag_alert text_uppercase">
                                <span className="material-icons">
                                  error_outline
                                </span>
                                {val.status.tag}
                              </div>
                            )}
                          </CardTop>
                          <CardBody id="card body">
                            <ul className="list-icon_small p0 m0_mobile">
                              <li className="item-double font-16">
                                {phrases?.["14523"]}{" "}
                                <span>{val.instrumentTypeName}</span>
                              </li>
                              <li className="flex justify-content_between g2 font-16">
                                <span>{phrases?.["14522"]}</span>
                                <span
                                  style={{
                                    wordBreak: "break-all",
                                  }}
                                >
                                  {val.name}
                                </span>
                              </li>
                              <li className="flex justify-content_between g2 font-16">
                                <span>{phrases?.["20022535"]}</span>
                                <span
                                  style={{
                                    wordBreak: "break-all",
                                  }}
                                >
                                  {buildDeviceNames(val.deviceType, deviceList)}
                                </span>
                              </li>
                              <li className="item-double font-16">
                                {phrases?.["20023506"]}
                                <span>
                                  {val.timeLimit == 0 &&
                                    val.timedByTopic == false &&
                                    val.timeByQuestion == false &&
                                    "N/A"}
                                  {(val.timeByQuestion == true ||
                                    val.timedByTopic == true ||
                                    val.timeLimit != 0) &&
                                    accessibilityStatus != 2 &&
                                    phrases?.["20023537"]}
                                  {(val.timeByQuestion == true ||
                                    val.timedByTopic == true ||
                                    val.timeLimit != 0) &&
                                    accessibilityStatus == 2 &&
                                    grantExtratiming == 0 &&
                                    phrases?.["20023537"]}
                                  {(val.timeByQuestion == true ||
                                    val.timedByTopic == true ||
                                    val.timeLimit != 0) &&
                                    grantExtratiming != 0 &&
                                    accessibilityStatus == 2 &&
                                    phrases?.["20023513"]}
                                </span>
                              </li>
                            </ul>
                          </CardBody>
                          <CardFooter id="card footer">
                            {val.status.id !== 2 &&
                              val.status.id !== 3 &&
                              val.status.id !== 6 && (
                                <a
                                  role="link"
                                  className={cn(
                                    val.status.disabled ||
                                      !showStartTestButton(val)
                                      ? "disabled"
                                      : "",
                                    "text_uppercase"
                                  )}
                                  onClick={() => {
                                    startAssessment(val, user);
                                  }}
                                >
                                  {showStartTestButton(val)
                                    ? val.status.tag
                                    : deviceList["desktopLabel"]}
                                  <span className="material-icons-outlined right">
                                    start
                                  </span>
                                </a>
                              )}
                          </CardFooter>
                        </Card>
                      </div>
                    ))}
                </div>
                <div className="clearfix" />
              </div>
              {user.fromCsso && user.fromMultisession ? (
                <div>
                  <button
                    className="text_uppercase button-secondary full-width_mobile"
                    onClick={cssoBack}
                  >
                    {phrases?.["15073"]}
                  </button>
                </div>
              ) : user.fromCsso ? (
                <div>
                  <button
                    className="text_uppercase button-secondary full-width_mobile"
                    onClick={cssologout}
                  >
                    {phrases?.["14870"]}
                  </button>
                </div>
              ) : (
                !user.inBranch && (
                  <div>
                    <button
                      className="text_uppercase button-secondary full-width_mobile"
                      onClick={signout}
                    >
                      {phrases?.["14870"]}
                    </button>
                  </div>
                )
              )}
            </>
          )}
          <div className="clearfix" />

          {showLangPopup && (
            <LanguageSelector
              closePopup={sharePopupClose}
              assignmentId={user.sessionId}
              phrases={phrases}
              clangId={user.siteConfig.langId}
              setSelectedLang={setSelectedLang}
            />
          )}
          {cookieShow && (
            <CookieMessage className="bg01 left_0">
              <CookieMessageBody className="base">
                <div
                  dangerouslySetInnerHTML={{
                    __html: cookieMsg(),
                  }}
                ></div>
              </CookieMessageBody>
              <CookieMessageRight>
                <button
                  style={{ width: "auto" }}
                  className="text_uppercase"
                  onClick={() => {
                    setCookieShow(false);
                    sessionStorage.setItem("cookieShow", JSON.stringify(false));
                  }}
                >
                  {phrases?.["57"]}
                </button>
              </CookieMessageRight>
            </CookieMessage>
          )}
        </>
      )}
    </>
  );
};

export default WelcomeScreen;
